import React, { useState, useEffect } from "react";
import AuthUser from "../Auth/AuthUser";
import {
    useMediaQuery,
    Grid,
    Select,
    FormControl,
    MenuItem,
    Input,
    InputLabel,
    FormLabel,
    RadioGroup,
    Radio,
    TextField,
    InputAdornment,
    Tooltip,
    ClickAwayListener,
    OutlinedInput,
    Backdrop,
    Checkbox,
    FormControlLabel,
    Stack,FormHelperText,IconButton
} from "@mui/material";
import { Typography, Card, CardContent, CardOverflow, Button } from "@mui/joy";
import NotificationsIcon from "@material-ui/icons/Notifications";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import SpeakerNotesOffIcon from "@mui/icons-material/SpeakerNotesOff";
import * as Yup from "yup";
import { Formik, FieldArray } from "formik";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import SnapshotOperationalHours from '../../Components/SnapshotOperationalHours';
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import swal from "sweetalert";
import InputMask from "react-input-mask";
import { useDispatch } from "react-redux";
import { postData, postFormData } from "../../redux/apiSlice";
import Freez from "../../Components/Loader/Loader";
import { styled } from "@mui/material/styles";
import SnapshotOperationalHours from "./SnapshotOperationalHours";
import iIcon from "../../assets/images/i_icon.png";
import InfoIcon from "@mui/icons-material/Info";
import Visibility from "@mui/icons-material/Visibility";

let blankValueIndexes1 = [];
let blankValueIndexes2 = [];
let operationalhoursvalues = [];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 350,
        },
    },
};

const CustomInputAdornment = styled(InputAdornment)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: 0,
    "& .MuiIconButton-root": {
        padding: "3px", // Apply reduced padding to all IconButtons
    },
}));

const CommonConfiguration = ({ receivedphone, defaultPhoneNumber,
    receivedemails,
    defaultEmail,
    receivedpid,
    receivedaid,
    business,
    creditinfo,
    pids,
    aidlist1,
    firstAid,
    receivedshift,
    fetchCreditInfo,
    defaultOutOfOfficeMsg,
    defaultTimezone
}) => {
    const { http, user } = AuthUser();
    const isMobile = useMediaQuery("(max-width:600px)");
    const [signupLinkLabel, setSignupLinkLabel] = useState(creditinfo && creditinfo.data && creditinfo.data.crs_signup_enabled === 1 ? "Add Your Customer Signup Link*" : "Add Your Customer Signup Link");
    const dispatch = useDispatch();
    const [freez, setFreez] = React.useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);
    const handleTooltipOpen = () => {
        setOpenTooltip(true);
    };

    const handleTooltipClose = () => {
        setOpenTooltip(false);
    };
    // tooltip popup end here
    const CustomSelect = styled(Select)(({ theme }) => ({
        "& .MuiInput-underline:before": {
            borderBottom: "none",
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none",
        },
    }));

    const CustomInputLabel = styled(InputLabel)(({ theme }) => ({
        "&.Mui-focused": {
            color: theme.palette.text.primary,
        },
    }));

    function formatPhoneNumber(phoneNumber) {
        const cleaned = ("" + phoneNumber).replace(/\D/g, ""); // Remove non-digits
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }

        return phoneNumber; // Return original input if it doesn't match the expected format
    }

    const phoneRegExp = /^\(\d{3}\) \d{3}-\d{4}$/;

    const validateVideoUrl = (url) => {
        // Regex for video file extensions
        const videoFileRegex = /\.(mp4|webm|ogg|avi|mov|mkv)$/i;

        // Regex for video platforms like YouTube and Vimeo
        const videoPlatformRegex = /(youtube\.com|youtu\.be|vimeo\.com)/i;

        // Validate URL as video link
        if (videoFileRegex.test(url) || videoPlatformRegex.test(url)) {
            return true;
        }
        return false;
    };

    const validationSchema = Yup.object().shape({
        phoneNumbers: Yup.array().of(
            Yup.object().shape({
                number: Yup.string()
                    .matches(
                        phoneRegExp,
                        "Phone number must match the pattern (123) 456-7890"
                    )
                    // .min(14, 'Must be 10 digits...')
                    // .max(14, 'Must be 10 digits.')
                    .required("Phone number is required"),
            })
        ),
        timezone: Yup.string().required("Please select Timezone."),
        emails: Yup.array().of(
            Yup.object().shape({
                email: Yup.string()
                    .email("Invalid Email Format.")
                    .matches(
                        /^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i,
                        "Invalid email format."
                    )
                    .required("Please enter your Email Address."),
            })
        ),
        // creditSnapshotLink: Yup.string().when("signupEnabled", {
        //     is: (signupEnabled) => signupEnabled == true,
        //     then: (schema) => schema
        //         .required('Credit Repair Signup Link is Required')
        //         .url('Please enter a valid URL.'),
        // }),
    });

    const handleChildValue = (value1) => {
        blankValueIndexes1 = [];
        blankValueIndexes2 = [];
        operationalhoursvalues = value1;
        if (value1.length == 2) {
            value1[0]["timings"].forEach((value, index) => {
                if (
                    value.start === "" ||
                    value.start === null ||
                    value.start === undefined
                ) {
                    blankValueIndexes1.push(index);
                }
                if (value.end === "" || value.end === null || value.end === undefined) {
                    blankValueIndexes1.push(index);
                }
            });
            value1[1]["timings"].forEach((value, index) => {
                if (
                    value.start === "" ||
                    value.start === null ||
                    value.start === undefined
                ) {
                    blankValueIndexes2.push(index);
                }
                if (value.end === "" || value.end === null || value.end === undefined) {
                    blankValueIndexes2.push(index);
                }
            });
        } else {
            value1[0]["timings"].forEach((value, index) => {
                if (
                    value.start === "" ||
                    value.start === null ||
                    value.start === undefined
                ) {
                    blankValueIndexes1.push(index);
                }
                if (value.end === "" || value.end === null || value.end === undefined) {
                    blankValueIndexes1.push(index);
                }
            });
        }
    };

    const CreateSnapInfo = async (values) => {
        if (blankValueIndexes1.length > 0) {
            swal({
                title: "Alert",
                text: "Some fields are missing in weekdays (Monday - Friday) shift either delete the shift or add its valus!",
                icon: "error",
                button: "Ok",
            });
        } else if (blankValueIndexes2.length > 0) {
            swal({
                title: "Alert",
                text: "Some fields are missing in weekends (Saturday - Sunday) shift either delete the shift or add its valus!",
                icon: "error",
                button: "Ok",
            });
        } else {
            console.log(values.phoneNumbers);
            const numArray = [];
            let errorFlag = 0;
            const numbers = values.phoneNumbers;
            if (Object.values(numbers).length > 0) {
                numbers.map((row, index) => {
                    if (numArray.includes(row.number.trim())) {
                        alert(row.number.trim() + " is duplicate, Please check.");
                        errorFlag = 1;
                        return false;
                    } else {
                        numArray.push(row.number.trim());
                    }
                });
            }

            const emailArray = [];
            let errorEmailFlag = 0;
            const emails = values.emails;
            if (Object.values(emails).length > 0) {
                emails.map((row, index) => {
                    if (emailArray.includes(row.email.trim())) {
                        alert(row.email.trim() + " is duplicate, Please check.");
                        errorEmailFlag = 1;
                        return false;
                    } else {
                        emailArray.push(row.email.trim());
                    }
                });
            }

            if (errorFlag === 1) {
                return false;
            } else if (errorEmailFlag === 1) {
                return false;
            } else {
                setFreez(true);
                operationalhoursvalues =
                    operationalhoursvalues.length == 0
                        ? receivedshift
                        : operationalhoursvalues;
                const formData = new FormData();
                // Append other fields
                formData.append("phone", JSON.stringify(values.phoneNumbers));
                formData.append("email", JSON.stringify(values.emails));
                formData.append(
                    "operationalhours",
                    JSON.stringify(operationalhoursvalues)
                );
                formData.append("timezone", values.timezone);
                // formData.append('creditSnapshotLink', values.creditSnapshotLink);
                // formData.append('snapshotStatus', values.snapshotStatus == true ? 1 : 0);
                // formData.append('fundingshotStatus', values.fundingshotStatus == true ? 1 : 0);
                // formData.append('signupEnabled', values.signupEnabled == true ? "true" : "false");
                formData.append('configuaration', true);
                const apiUrl = "/updateSnapshotDetails";

                const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();
                if (res) {
                    if (res.success === true) {
                        fetchCreditInfo();
                        swal({
                            title: "Success",
                            text: res.message,
                            icon: "success",
                            button: "Ok",
                        });
                    } else {
                        swal({
                            title: "Alert",
                            text: "Something went wrong please try again",
                            icon: "error",
                            button: "Ok",
                        });
                    }
                }
                setFreez(false);
            }
        }
    };

    return (
        <>
            <div>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
            <Card>
                <Formik
                    initialValues={{
                        phoneNumbers: receivedphone
                            ? receivedphone
                            : [
                                {
                                    number: formatPhoneNumber(defaultPhoneNumber),
                                    notifications: true,
                                    chatoption: true,
                                },
                            ],
                        emails: receivedemails
                            ? receivedemails
                            : [
                                {
                                    email: defaultEmail,
                                    notifications: true,
                                    chatoption: true,
                                },
                            ],
                        timezone: defaultTimezone ? defaultTimezone:'',
                        creditSnapshotLink: creditinfo ? creditinfo.data ? creditinfo.data.credit_snapshot_link ? creditinfo.data.credit_snapshot_link : "" : "" : "",
                        signupEnabled :  creditinfo ? creditinfo.data ? (creditinfo.data.crs_signup_enabled == 1) ? true : false : false : false,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, errors) => {
                        CreateSnapInfo(values);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        setFieldTouched,
                        handleSubmit,
                        setFieldValue,
                        setFieldError,
                    }) => (
                        <div>
                          
                                <Grid
                                    container
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    spacing={4}
                                >
                                    <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
                                        <Typography level="h6" sx={{ fontWeight: "bold" }}>
                                            Setup Your Information For Lead Generation Tools
                                        </Typography>
                                        <FieldArray
                                            name="phoneNumbers"
                                            render={({ push, remove }) => (
                                                <div>
                                                    {values.phoneNumbers.map((phoneNumber, index) => (
                                                        <Grid
                                                            item
                                                            lg={12}
                                                            md={12}
                                                            sm={12}
                                                            xs={12}
                                                            key={index}
                                                        >
                                                            <FormControl
                                                                fullWidth
                                                                margin="dense"
                                                                size="small"
                                                            >
                                                                <InputMask
                                                                    mask="(999) 999-9999"
                                                                    maskChar={null}
                                                                    disabled={user.roles_id > 3 ? true : false}
                                                                    value={formatPhoneNumber(phoneNumber.number)}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        Boolean(phoneNumber.number) &&
                                                                        Boolean(errors.phoneNumbers) &&
                                                                        Boolean(errors.phoneNumbers[index]) &&
                                                                        Boolean(errors.phoneNumbers[index].number)
                                                                    }
                                                                    helperText={
                                                                        errors.phoneNumbers &&
                                                                        errors.phoneNumbers[index] &&
                                                                        errors.phoneNumbers[index].number
                                                                    }
                                                                >
                                                                    {() => (
                                                                        <TextField
                                                                            size="small"
                                                                            margin="dense"
                                                                            disabled={
                                                                                user.roles_id > 3 ? true : false
                                                                            }
                                                                            label={`Mobille Phone Number*`}
                                                                            name={`phoneNumbers[${index}].number`}
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <CustomInputAdornment position="end">
                                                                                        {phoneNumber.notifications ? (
                                                                                            <IconButton
                                                                                                color="primary"
                                                                                                onClick={() =>
                                                                                                    setFieldValue(
                                                                                                        `phoneNumbers[${index}].notifications`,
                                                                                                        index === 0
                                                                                                            ? true
                                                                                                            : !values.phoneNumbers[
                                                                                                                index
                                                                                                            ].notifications
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <Tooltip title="Text Notification Enabled">
                                                                                                    <NotificationsIcon
                                                                                                        fontSize="small"
                                                                                                        style={{ color: "#76C044" }}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            </IconButton>
                                                                                        ) : (
                                                                                            <IconButton
                                                                                                color="secondary"
                                                                                                onClick={() =>
                                                                                                    setFieldValue(
                                                                                                        `phoneNumbers[${index}].notifications`,
                                                                                                        !values.phoneNumbers[index]
                                                                                                            .notifications
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <Tooltip title="Text Notification Disabled">
                                                                                                    <NotificationsOffIcon
                                                                                                        fontSize="small"
                                                                                                        style={{ color: "red" }}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            </IconButton>
                                                                                        )}

                                                                                        {phoneNumber.chatoption ? (
                                                                                            <IconButton
                                                                                                color="primary"
                                                                                                onClick={() =>
                                                                                                    setFieldValue(
                                                                                                        `phoneNumbers[${index}].chatoption`,
                                                                                                        index === 0
                                                                                                            ? true
                                                                                                            : !values.phoneNumbers[
                                                                                                                index
                                                                                                            ].chatoption
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <Tooltip title="Chat Notification Enabled">
                                                                                                    <SpeakerNotesIcon
                                                                                                        fontSize="small"
                                                                                                        style={{ color: "#76C044" }}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            </IconButton>
                                                                                        ) : (
                                                                                            <IconButton
                                                                                                color="secondary"
                                                                                                onClick={() =>
                                                                                                    setFieldValue(
                                                                                                        `phoneNumbers[${index}].chatoption`,
                                                                                                        !values.phoneNumbers[index]
                                                                                                            .chatoption
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <Tooltip title="Chat Notification Disabled">
                                                                                                    <SpeakerNotesOffIcon
                                                                                                        fontSize="small"
                                                                                                        style={{ color: "red" }}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            </IconButton>
                                                                                        )}
                                                                                        {index > 0 && (
                                                                                            <IconButton
                                                                                                color="secondary"
                                                                                                onClick={() => remove(index)}
                                                                                            >
                                                                                                {user.roles_id <= 3 ? (
                                                                                                    <DeleteOutline
                                                                                                        fontSize="small"
                                                                                                        style={{ color: "grey" }}
                                                                                                    />
                                                                                                ) : null}
                                                                                            </IconButton>
                                                                                        )}
                                                                                        {user.roles_id <= 3 &&
                                                                                            values.phoneNumbers.length < 5 ? (
                                                                                            <IconButton
                                                                                                color="primary"
                                                                                                onClick={() => {
                                                                                                    push({
                                                                                                        number: "",
                                                                                                        notifications: false,
                                                                                                        chatoption: false,
                                                                                                    });
                                                                                                }}
                                                                                            >
                                                                                                <AddCircleOutlineIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        ) : null}
                                                                                    </CustomInputAdornment>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    )}
                                                                </InputMask>

                                                                {errors.phoneNumbers &&
                                                                    errors.phoneNumbers[index] &&
                                                                    errors.phoneNumbers[index].number && (
                                                                        <FormHelperText error>
                                                                            {errors.phoneNumbers[index].number}
                                                                        </FormHelperText>
                                                                    )}
                                                            </FormControl>
                                                        </Grid>
                                                    ))}
                                                </div>
                                            )}
                                        />

                                        <FieldArray
                                            name="emails"
                                            render={({ push, remove }) => (
                                                <div>
                                                    {values.emails.map((email, index) => (
                                                        <Grid
                                                            item
                                                            lg={12}
                                                            md={12}
                                                            sm={12}
                                                            xs={12}
                                                            key={index}
                                                        >
                                                            <FormControl
                                                                fullWidth
                                                                margin="dense"
                                                                size="small"
                                                            >
                                                                <TextField
                                                                    size="small"
                                                                    margin="dense"
                                                                    disabled={user.roles_id > 3 ? true : false}
                                                                    value={email.email}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        Boolean(email.email) &&
                                                                        Boolean(errors.emails) &&
                                                                        Boolean(errors.emails[index]) &&
                                                                        Boolean(errors.emails[index].email)
                                                                    }
                                                                    label={`Email*`}
                                                                    name={`emails[${index}].email`}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <CustomInputAdornment position="end">
                                                                                {email.notifications ? (
                                                                                    <IconButton
                                                                                        color="primary"
                                                                                        onClick={() =>
                                                                                            setFieldValue(
                                                                                                `emails[${index}].notifications`,
                                                                                                index === 0
                                                                                                    ? true
                                                                                                    : !values.emails[index]
                                                                                                        .notifications
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <Tooltip title="Email Notification Enabled">
                                                                                            <NotificationsIcon
                                                                                                fontSize="small"
                                                                                                style={{ color: "#76C044" }}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </IconButton>
                                                                                ) : (
                                                                                    <IconButton
                                                                                        color="secondary"
                                                                                        onClick={() =>
                                                                                            setFieldValue(
                                                                                                `emails[${index}].notifications`,
                                                                                                !values.emails[index]
                                                                                                    .notifications
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <Tooltip title="Email Notification Disabled">
                                                                                            <NotificationsOffIcon
                                                                                                fontSize="small"
                                                                                                style={{ color: "red" }}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </IconButton>
                                                                                )}
                                                                                {email.chatoption ? (
                                                                                    <IconButton
                                                                                        color="primary"
                                                                                        onClick={() =>
                                                                                            setFieldValue(
                                                                                                `emails[${index}].chatoption`,
                                                                                                index === 0
                                                                                                    ? true
                                                                                                    : !values.emails[index]
                                                                                                        .chatoption
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <Tooltip title="Chat Notification Enabled">
                                                                                            <SpeakerNotesIcon
                                                                                                fontSize="small"
                                                                                                style={{ color: "#76C044" }}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </IconButton>
                                                                                ) : (
                                                                                    <IconButton
                                                                                        color="secondary"
                                                                                        onClick={() =>
                                                                                            setFieldValue(
                                                                                                `emails[${index}].chatoption`,
                                                                                                !values.emails[index].chatoption
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <Tooltip title="Chat Notification Disabled">
                                                                                            <SpeakerNotesOffIcon
                                                                                                fontSize="small"
                                                                                                style={{ color: "red" }}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </IconButton>
                                                                                )}
                                                                                {index > 0 && (
                                                                                    <IconButton
                                                                                        color="secondary"
                                                                                        onClick={() => remove(index)}
                                                                                    >
                                                                                        {user.roles_id <= 3 ? (
                                                                                            <DeleteOutline
                                                                                                fontSize="small"
                                                                                                style={{ color: "grey" }}
                                                                                            />
                                                                                        ) : null}
                                                                                    </IconButton>
                                                                                )}
                                                                                {user.roles_id <= 3 &&
                                                                                    values.emails.length < 5 ? (
                                                                                    <IconButton
                                                                                        color="primary"
                                                                                        onClick={() => {
                                                                                            push({
                                                                                                email: "",
                                                                                                notifications: false,
                                                                                                chatoption: false,
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        <AddCircleOutlineIcon fontSize="small" />
                                                                                    </IconButton>
                                                                                ) : null}
                                                                            </CustomInputAdornment>
                                                                        ),
                                                                    }}
                                                                />
                                                                {errors.emails &&
                                                                    errors.emails[index] &&
                                                                    errors.emails[index].email && (
                                                                        <FormHelperText error>
                                                                            {errors.emails[index].email}
                                                                        </FormHelperText>
                                                                    )}
                                                            </FormControl>
                                                        </Grid>
                                                    ))}
                                                </div>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
                                        <Grid
                                            container
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            sx={{ textAlign: "left", display: "block" }}
                                        >
                                            <Typography
                                                level="h6"
                                                sx={{ fontWeight: "bold", textAlign: "left" }}
                                            >
                                                Days & Hours Of Operation{" "}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            md={6}
                                            container
                                            spacing={1}
                                            mt={2}
                                            sx={{ alignSelf: "flex-start" }}
                                        >
                                            <Grid container item md={12}>
                                                <FormControl fullWidth size="small" margin="dense">
                                                    <InputLabel id="demo-multiple-name-label">
                                                        Timezone*
                                                    </InputLabel>
                                                    <Select
                                                        name="timezone"
                                                        labelId="demo-simple-select-label"
                                                        id="timezone"
                                                        value={values.timezone || ""}
                                                        label="Timezone"
                                                        fullWidth
                                                        size="small"
                                                        margin="dense"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        MenuProps={MenuProps}
                                                    >
                                                        <MenuItem value="PST">
                                                            PST - Pacific Standard Time
                                                        </MenuItem>
                                                        {/* <MenuItem value="CT">CT - Central Time</MenuItem> */}
                                                        <MenuItem value="EST">
                                                            EST - Eastern Standard Time
                                                        </MenuItem>
                                                        <MenuItem value="Asia/Kolkata">
                                                            IST - Indian Standard Time
                                                        </MenuItem>
                                                        <MenuItem value="EDT">
                                                            EDT - Eastern Daylight Time
                                                        </MenuItem>
                                                        <MenuItem value="UTC">
                                                            UTC - Coordinated Universal Time
                                                        </MenuItem>
                                                        <MenuItem value="PDT">
                                                            PDT - Pacific Daylight Time
                                                        </MenuItem>
                                                        <MenuItem value="WET">
                                                            WET - Western European Time
                                                        </MenuItem>
                                                        <MenuItem value="CDT">
                                                            CDT - Central Daylight Time
                                                        </MenuItem>
                                                        <MenuItem value="Australia/Perth">
                                                            WST - Western Standard Time
                                                        </MenuItem>
                                                        <MenuItem value="CST">
                                                            CST - Central Standard Time
                                                        </MenuItem>
                                                        <MenuItem value="MST">
                                                            MST - Mountain Standard Time
                                                        </MenuItem>
                                                        <MenuItem value="HST">
                                                            HST - Hawaii Standard Time
                                                        </MenuItem>
                                                    </Select>
                                                    {touched.timezone && errors.timezone ? (
                                                        <div className="error">{errors.timezone}</div>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                            <SnapshotOperationalHours
                                                id="OperationalHours1"
                                                name="OperationalHours1"
                                                onValueChange={handleChildValue}
                                                props={receivedshift}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <FormControlLabel control={<Checkbox checked={values.signupEnabled} />}
                                        label={
                                            <span style={{ fontWeight: "bold" }}>
                                                Add Your Auto Customer Signup Link For Your CRM
                                            </span>
                                        }
                                        onChange={(e) => {
                                            // showOrHideChatInputs(!values.signupEnabled)
                                            setFieldValue('signupEnabled', !values.signupEnabled, true)
                                            setSignupLinkLabel("Customer Signup Link*");
                                        }}
                                    />
                                </Grid> */}
                                {/* {
                                    values.signupEnabled ?
                                        <Grid item lg={6} md={6} sm={6} xs={6}>

                                            <TextField
                                                label={signupLinkLabel}
                                                variant="outlined"
                                                id="creditSnapshotLink"
                                                name="creditSnapshotLink"
                                                size="small"
                                                fullWidth
                                                margin="dense"
                                                value={values.creditSnapshotLink}
                                                onChange={handleChange}
                                                onBlur={handleChange}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <ClickAwayListener onClickAway={handleTooltipClose}>
                                                                <div>
                                                                    <Tooltip
                                                                        PopperProps={{
                                                                            disablePortal: true, // Ensures the tooltip stays within bounds
                                                                        }}
                                                                        onClose={handleTooltipClose}
                                                                        open={openTooltip}
                                                                        disableFocusListener
                                                                        disableHoverListener
                                                                        disableTouchListener
                                                                        title={
                                                                            <div >
                                                                                <p sx={{ fontSize: "100px" }}>
                                                                                    Enter The Link Below <br />
                                                                                    Where Your Clients Can <br />
                                                                                    Automatically Signup <br />
                                                                                    For Your Services.
                                                                                </p>
                                                                            </div>
                                                                        }
                                                                        placement="top-start"
                                                                        interactive
                                                                    >
                                                                        <IconButton
                                                                            aria-label="toggle tooltip"
                                                                            edge="end"
                                                                            onClick={handleTooltipOpen}
                                                                        >
                                                                            <img src={iIcon} alt="info" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                            </ClickAwayListener>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            {touched.creditSnapshotLink && errors.creditSnapshotLink ? <div className='error'>{errors.creditSnapshotLink}</div> : null}

                                        </Grid>
                                        : <Grid item lg={6} md={6} sm={6} xs={6}>
                                        </Grid>} */}
                                {user.roles_id <= 3 ? (
                                    <>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            sx={{ display: "flex", justifyContent: "center" }}
                                            mt={2}
                                        >
                                            <Button
                                                sx={{ minWidth: 350, maxWidth: 300 }}
                                                className="CustomButton"
                                                onClick={handleSubmit}
                                            >
                                                SAVE INFORMATION
                                            </Button>
                                        </Grid>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            mt={2}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    fontSize: "16px",
                                                    textAlign: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    margin: 0,
                                                }}
                                            >
                                                <span>
                                                    <i>
                                                        <img
                                                            src={require("../../assets/images/snapVector.png")}
                                                            alt="Snap Vector"
                                                            style={{ width: "25px", verticalAlign: "middle" }}
                                                        />{" "}
                                                        Ensure All Required Fields Are Completed And
                                                        Remember To Save.
                                                    </i>{" "}
                                                </span>
                                            </p>
                                        </Grid>

                                    </>
                                ) : null}
                         
                        </div>
                    )}
                </Formik>
                {/* formik end */}
            </Card>
        </>
    );
};

export default CommonConfiguration;
